export const en = {
    "k_9fbdbc0a": "Whether to allow the data source interface to be called through the \"MCP Proxy\"",
    "k_54b43f9c": "MCP Agent Management",
    "k_e63b073": "MCP proxy key",
    "k_14a8fd6f": "Generating SKILL"
};
